import axios from "axios";

export const loginAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/login`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
      withCredentials: true,
    }
  );

  return response.data;
};

export const accessTokenAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/access_Token?email=${payload.email}`,
    null,
    {
      withCredentials: true,
    }
  );

  return response.data;
};

export const logoutAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/logout`
  );

  localStorage.removeItem("firstlogin");
  return response;
};

export const getUserDetailsAction = async (token) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/getUserInformation`,
    {
      withCredentials: true,
      headers: {
        Authorization: token,
      },
    }
  );

  return response.data;
};

export const getCompanyPermissionAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/getCompanyPermission?companyId=${payload.companyId}`,
    {
      withCredentials: true,
      headers: {
        Authorization: payload?.token,
      },
    }
  );

  return response.data;
};

export const editUserAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/user/updateUser?id=${payload.userId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const updateUserPermissionAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/permission/updatePermission?userId=${payload.userId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const updateUserPasswordAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/user/updatePasswordByAdmin?userId=${payload.userId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const unloackUserAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/unlockUser?userId=${payload.userId}`,

    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const lockUserAction = async (payload) => {
  const response = await axios.get(
    `${process.env.REACT_APP_BASE_URL}/user/lockUser?userId=${payload.userId}`,

    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const registerMailAction = async (payload) => {
  const response = await axios.post(
    `${process.env.REACT_APP_BASE_URL}/user/registermail`,
    payload,
    {
      headers: {
        "Content-Type": "application/json",
      },
    }
  );

  return response;
};

export const userRoleUpdateAction = async (payload) => {
  const response = await axios.patch(
    `${process.env.REACT_APP_BASE_URL}/user/updatRole?id=${payload.userId}`,
    payload.body,
    {
      headers: {
        Authorization: payload.token,
      },
    }
  );
  return response;
};

export const getUserDetailsInitialAction = async (payload) => {
  await axios.get(`${process.env.REACT_APP_BASE_URL}/bookings/getUserDetail`, {
    withCredentials: true,
    headers: {
      Authorization: payload.token,
    },
  });
};
